import { Button, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import CircularLoading from "../../../../commons/loading/CircularLoading";
import ResponsablesCard from "../../../../commons/responsables/responsablesCard/ResponsablesCard";
import ResponsablesEnum from "../../../../enums/responsablesEnum";
import { getResponsablesFormValidation } from "../../validation/formValidation";

const ResponsablesForm = ({
  handleOpenDialog,
  model,
  handleSubmit,
  isLoading,
  isResponsableSHRequired,
}) => {

  return (
    <>
      {!isLoading ? (
        <Formik
          initialValues={model}
          onSubmit={handleSubmit}
          validationSchema={getResponsablesFormValidation(isResponsableSHRequired)}
          enableReinitialize={true}
        >
          {({ values }) => (
            <Form>
              <Grid container spacing={2} style={{ marginTop: 1 }}>
                <Grid item xs={6}>
                  <ResponsablesCard
                    name="responsableDeDatos"
                    title="Responsable de los Datos Declarados"
                    handleOpenAddResponsable={handleOpenDialog}
                    required
                    fieldLabel="Responsable de Datos"
                    variant="vertical"
                  />
                </Grid>
                <Grid item xs={6}>
                  <ResponsablesCard
                    name="responsableDeSeguridad"
                    responsableType={ResponsablesEnum.seguridadHigiene}
                    title="Responsable de Seguridad e Higiene"
                    handleOpenAddResponsable={handleOpenDialog}
                    fieldLabel="Responsable de S y H"
                    variant="vertical"
                    required={isResponsableSHRequired}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 5,
                  }}
                >
                  <Button variant="contained" color="primary" type="submit">
                    Siguiente
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      ) : (
        <CircularLoading />
      )}
    </>
  );
};

export default ResponsablesForm;
